import { ICustomer } from '../../../shared/models/be/customers';

export interface DiagnosticScope {
  type: 'organization' | 'customer' | 'global';
  label: string;
  description: string;
  customerId?: number;
  organizationId?: string;
}

export interface SensorConnectivityTarget {
  label: string;
  customerId?: number;
  organizationId?: string;
  filters: Array<{ id: 'customer' | 'organization'; value: string }>;
}

export function buildSensorConnectivityTargets(
  scope: DiagnosticScope,
  customers: ICustomer[]
): SensorConnectivityTarget[] {
  if (scope.organizationId) {
    return [{
      label: scope.label.replace(/^Organizzazione:\s*/, ''),
      customerId: scope.customerId,
      organizationId: scope.organizationId,
      filters: [{ id: 'organization', value: scope.organizationId }]
    }];
  }

  if (scope.customerId !== undefined) {
    return [{
      label: scope.label.replace(/^Cliente:\s*/, ''),
      customerId: scope.customerId,
      filters: [{ id: 'customer', value: String(scope.customerId) }]
    }];
  }

  return customers.map(customer => ({
    label: customer.businessName,
    customerId: customer.id,
    filters: [{ id: 'customer', value: String(customer.id) }]
  }));
}
